<template>
  <div>
    <v-snackbar v-model="avviso_avvio" bottom shaped color="green">
      <v-icon class="mr-2">mdi-information</v-icon>
      Il mezzo selezionato si trova in azienda e la consegna verrà avviata non
      appena partirà.
    </v-snackbar>

    <v-snackbar v-model="snack_mezzo_offline" bottom shaped color="error">
      <v-icon>mdi-alert</v-icon>
      Il mezzo selezionato risulta offline.
    </v-snackbar>
    <ConsegnaDettaglio
      :consegna="consegna"
      :ordini="ordini"
      ref="consegna_dettaglio"
    />
    <v-row v-if="loading" align="center">
      <v-col cols="1">
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col cols="2" class="">
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col cols="2" class="">
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col cols="2" class="d-flex align-center">
        <v-row no-gutters class="" justify="center" align="center">
          <v-skeleton-loader class="" type="avatar"></v-skeleton-loader>
        </v-row>
      </v-col>
      <v-col cols="1" class="">
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col cols="1" class="">
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col cols="2" class="d-flex align-center">
        <v-skeleton-loader type="button" class="mx-1"></v-skeleton-loader>
        <v-skeleton-loader type="button" class="mx-1"></v-skeleton-loader>
        <v-skeleton-loader type="button" class="mx-1"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row align="center" v-else>
      <v-col cols="1" class="d-flex justify-center"
        ># {{ consegna.numero }}
      </v-col>
      <v-col cols="2">
        <template
          v-for="(tappa, index) in consegna.tappe.filter(
            (tappa) => !tappa.ritorno
          )"
        >
          <div class="text-truncate" :key="tappa.id">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on"
                  ><v-icon
                    size="15"
                    class="mt-n1 mr-1"
                    :color="stato_tappa(tappa).colore"
                    >{{ stato_tappa(tappa).icona }}</v-icon
                  >{{ index + 1 }} - {{ cliente(tappa.cliente).nome }}</span
                >
              </template>
              {{ index + 1 }} - {{ cliente(tappa.cliente).nome }}
            </v-tooltip>
          </div>
        </template>
      </v-col>
      <v-col cols="2">
        {{ partenza_prevista }}
      </v-col>
      <v-col cols="2" class="">
        <template v-if="consegna.stato == 1">
          <v-row no-gutters justify="center">
            <v-col cols="4" class="d-flex justify-center">
              <v-icon color="blue"> mdi-truck-fast </v-icon>
            </v-col>
            <v-col cols="8">
              <v-row no-gutters> In consegna </v-row>
              <v-row no-gutters>
                Status:
                <v-icon
                  v-if="!stato_mezzo.network"
                  color="red"
                  size="15"
                  class="ml-2"
                >
                  mdi-link-off
                </v-icon>
                <v-icon v-else color="green" size="15" class="ml-2">
                  mdi-link
                </v-icon>
                <template v-if="stato_mezzo.network">
                  <v-icon
                    v-if="!stato_mezzo.gps"
                    color="red"
                    size="15"
                    class="ml-2"
                  >
                    mdi-map-marker-off-outline
                  </v-icon>
                  <v-icon v-else color="green" size="15" class="ml-2">
                    mdi-map-marker-outline
                  </v-icon>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-if="consegna.stato == 0">
          <v-row no-gutters justify="center">
            <v-col cols="4" class="d-flex justify-center">
              <v-icon color="orange"> mdi-clock </v-icon>
            </v-col>
            <v-col cols="8">
              <v-row no-gutters> Programmata </v-row>
              <v-row no-gutters>
                Status:
                <v-icon
                  v-if="!stato_mezzo.network"
                  color="red"
                  size="15"
                  class="ml-2"
                >
                  mdi-link-off
                </v-icon>
                <v-icon v-else color="green" size="15" class="ml-2">
                  mdi-link
                </v-icon>
                <template v-if="stato_mezzo.network">
                  <v-icon
                    v-if="!stato_mezzo.gps"
                    color="red"
                    size="15"
                    class="ml-2"
                  >
                    mdi-map-marker-off-outline
                  </v-icon>
                  <v-icon v-else color="green" size="15" class="ml-2">
                    mdi-map-marker-outline
                  </v-icon>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-if="consegna.stato == 2">
          <v-row no-gutters justify="center">
            <v-icon color="green"> mdi-check-circle </v-icon>
          </v-row>
          <v-row no-gutters justify="center"> Completata </v-row>
        </template>
        <template v-if="consegna.stato == 3">
          <v-row no-gutters justify="center">
            <v-col cols="4" class="d-flex justify-center">
              <v-icon color="purple"> mdi-upload </v-icon>
            </v-col>
            <v-col cols="8">
              <v-row no-gutters> Attesa Mezzo </v-row>
              <v-row no-gutters>
                Status:
                <v-icon
                  v-if="!stato_mezzo.network"
                  color="red"
                  size="15"
                  class="ml-2"
                >
                  mdi-link-off
                </v-icon>
                <v-icon v-else color="green" size="15" class="ml-2">
                  mdi-link
                </v-icon>
                <template v-if="stato_mezzo.network">
                  <v-icon
                    v-if="!stato_mezzo.gps"
                    color="red"
                    size="15"
                    class="ml-2"
                  >
                    mdi-map-marker-off-outline
                  </v-icon>
                  <v-icon v-else color="green" size="15" class="ml-2">
                    mdi-map-marker-outline
                  </v-icon>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-if="consegna.stato == 4">
          <v-row no-gutters justify="center">
            <v-icon color="indigo"> mdi-bus-clock </v-icon>
          </v-row>
          <v-row no-gutters justify="center"> Attesa Arrivo Mezzo </v-row>
        </template>
      </v-col>
      <v-col cols="1">{{ tot_cc_carico }}</v-col>
      <v-col cols="2">
        {{ tempo_humanized }}
        <br />
        <template v-if="consegna.stato == 1">
          <span class="purple--text">Arrivo</span> {{ ora_arrivo_previsto }}
        </template>
        <template v-if="consegna.stato == 2">
          <!-- <span class="green--text">Arrivato alle </span> {{ ora_arrivo }} -->
        </template>
      </v-col>
      <v-col cols="2">
        <!-- <ConsegnaDettaglio :consegna="consegna" :ordini="ordini" /> -->
        <v-btn icon class="ml-8" @click="$refs.consegna_dettaglio.open()"
          ><v-icon color="blue">mdi-map</v-icon></v-btn
        >
    
        <v-btn
          v-if="consegna.archiviata"
          icon
          color="green"
          @click="attiva_consegna()"
        >
          <v-icon>mdi-recycle</v-icon>
        </v-btn>

        <!-- Avvia Consegna -->
         <AvvioConsegnaButton :consegna="consegna"/>

        <v-btn
          v-if="consegna.stato == 4 || consegna.stato == 3"
          color="red"
          icon
          :loading="annulla_loading"
          @click="annulla_consegna()"
          ><v-icon>mdi-cancel</v-icon></v-btn
        >
        <!-- Elimina Consegna -->
        <v-dialog v-model="dialog_elimina" width="400">
          <template v-slot:activator="{ on }">
            <v-btn icon color="red" v-on="on">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="red--text"> Elimina Consegna </v-card-title>
            <v-card-text> La consegna verrà eliminata. </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="red"
                :loading="loading_delete"
                @click="elimina_consegna()"
              >
                <v-icon class="mr-2">mdi-delete</v-icon>
                Elimina
              </v-btn>
              <v-btn text color="grey" @click="dialog_elimina = false"
                >Annulla</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-divider class="my-4" />
  </div>
</template>

<script>

import consegna_element_mixin from "../mixin/consegna_element_mixin";
import ConsegnaDettaglio from "./consegna_dettaglio_mappa";
import AvvioConsegnaButton from "./avvia_consegna_button.vue";

export default {
  components: {
    AvvioConsegnaButton,
    ConsegnaDettaglio,
  },
  mixins: [consegna_element_mixin],
};
</script>
